import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { JETSTREAM_SERVER_EU } from '~/app/models/constans';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	JetStreamServerUrl: JETSTREAM_SERVER_EU,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	hideConsumptionEmissionEngineName: true,
	showConsumptionEmissionTechData: false,
};
